var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('p',{staticClass:"copyright__text"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" Advarra, Inc. | "),_c('a',{staticClass:"copyright__link",attrs:{"target":"_blank","href":'https://app.longboat.com/gateway/privacy?locale=' + _vm.locale},domProps:{"innerHTML":_vm._s(_vm.$t('c_privacy'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }